export default "__VITE_ASSET__BF213Egi__"